import request from './request'

// 认证相关API

/**
 * 用户登录
 * @param {Object} data - 登录信息
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 */
export function login(data) {
  return request.post('/auth/login/json', data)
}

/**
 * 用户登出
 */
export function logout() {
  return request.post('/auth/logout')
}

/**
 * 获取当前用户信息
 */
export function getUserInfo() {
  return request.get('/auth/me')
}

/**
 * 刷新Token
 */
export function refreshToken() {
  return request.post('/auth/refresh')
}
